import {PropertyType, ResourceType} from 'common/widgets/property-filter-menu/models/types';
import {Segment} from 'common/widgets/query-block/segment-menu/types';

export const EVENT_FILTER = {
  resourceType: `event`,
  propertyName: `Number of kittens`,
  propertyDefaultType: `number`,
  propertyType: `number`,
  propertyObjectKey: null,
  filterOperator: `is greater than`,
  filterValue: 1,
};

export const PROPERTY_AGGREGATION = {
  label: `Number of kittens`,
  propertyDefaultType: `number`,
  resourceType: `event`,
  type: `number`,
  value: `Number of kittens`,
};

export const DEFAULT_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filtersOperator: `or`,
  property: null,
  type: `event`,
  filters: [EVENT_FILTER],
  event: {
    id: null,
    custom: false,
    label: `View kittens`,
    value: `View kittens`,
  },
};

export const ALL_USERS_ENTRY = {
  ...DEFAULT_EVENT,
  type: `user`,
  filters: [],
  readOnlyEvent: true,
  event: {
    label: `All People`,
    value: `$all_people`,
    resourceType: `cohort`,
  },
};

export const YOUR_TOP_EVENTS = {
  ...DEFAULT_EVENT,
  filters: [],
  event: {
    label: `Your Top Events`,
    value: `$top_events`,
  },
};

export const EMPTY_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filters: [],
  filtersOperator: `and`,
  property: null,
  type: `event`,
  event: {
    id: null,
    custom: false,
    label: ``,
    value: null,
  },
};

export const FLOWS_EVENT = {
  aggregationOperator: `total`,
  aggregationOperatorPerUser: null,
  filtersOperator: `or`,
  property: null,
  type: `flows_event`,
  filters: [EVENT_FILTER],
  event: {
    id: null,
    custom: false,
    label: `View kittens`,
    value: `View kittens`,
  },
  reverse: 1,
  forward: 2,
};

export const COHORT_SEGMENT = [[{cohort: {id: 1, negated: false, name: `Cohort One`}}]];

export const USER_SEGMENT = [
  {
    user: {
      resourceType: `user`,
      propertyName: `number of kittens owned`,
      propertyDefaultType: `number`,
      propertyType: `number`,
    },
  },
];

export const BILLING_DATA_GROUP_ID = `9292783`;
export const COMPANY_DATA_GROUP_ID = `2900955`;

export const USER_PROFILE_FILTER = {
  resourceType: `user`,
  propertyName: `number of kittens owned`,
  propertyDefaultType: `number`,
  propertyType: `number`,
  filterOperator: `is greater than`,
  filterValue: 1,
};

export const B2B_PROFILE_FILTER = {
  resourceType: `user`,
  dataGroupId: BILLING_DATA_GROUP_ID,
  propertyName: `Account Status`,
  propertyDefaultType: `string`,
  propertyType: `string`,
  filterOperator: `is set`,
  filterValue: null,
};

export const EVENT_WITH_B2B_FILTERS = {
  ...DEFAULT_EVENT,
  filters: [USER_PROFILE_FILTER, B2B_PROFILE_FILTER, EVENT_FILTER],
};

export const eventWithB2BFiltersSanitized = (dgid) => ({
  ...DEFAULT_EVENT,
  filters: [B2B_PROFILE_FILTER, EVENT_FILTER],
  dataGroupId: dgid,
});

export const EXCLUSION_EVENT_WITH_B2B_FILTERS = {
  ...DEFAULT_EVENT,
  filters: [USER_PROFILE_FILTER, B2B_PROFILE_FILTER, EVENT_FILTER],
  event: {id: null, custom: false, label: `Feed aardvarks`, value: `Feed aardvarks`},
  excludeRange: {},
};

export const exclusionEventWithB2BFiltersSanitized = (dgid) => ({
  ...DEFAULT_EVENT,
  filters: [B2B_PROFILE_FILTER, EVENT_FILTER],
  event: {id: null, custom: false, label: `Feed aardvarks`, value: `Feed aardvarks`},
  excludeRange: {},
  dataGroupId: dgid,
});

export const USER_COHORT_FILTER = {
  filterOperator: `contains`,
  propertyType: `list`,
  resourceType: `cohort`,
  filterValue: [{cohort: {id: 12, name: `a saved cohort`, negated: false}}],
};

export const INLINE_USER_COHORT_FILTER = {
  ...USER_COHORT_FILTER,
  filterValue: [
    {
      cohort: {
        name: `an inline user cohort`,
        negated: false,
        raw_cohort: {name: `an inline user cohort`, selector: {}, behaviors: {}},
      },
    },
  ],
};

export const B2B_COHORT_FILTER = {
  ...USER_COHORT_FILTER,
  filterValue: [
    {cohort: {dataGroupId: BILLING_DATA_GROUP_ID, id: 14, name: `saved billing account cohort`, negated: false}},
  ],
};

export const INLINE_B2B_COHORT_FILTER = {
  ...USER_COHORT_FILTER,
  filterValue: [
    {
      cohort: {
        dataGroupId: BILLING_DATA_GROUP_ID,
        name: `inline billing account cohort`,
        negated: false,
        raw_cohort: {name: `inline billing account cohort`, selector: {}, behaviors: {}},
      },
    },
  ],
};

export const EVENT_SEGMENT: Segment[] = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyName: `Number of kittens`,
      propertyDefaultType: PropertyType.Number,
      propertyType: PropertyType.Number,
    },
  },
];

export const SEGMENT_WITH_CUSTOM_BUCKET = [
  {
    event: {
      resourceType: ResourceType.Event,
      propertyDefaultType: PropertyType.Number,
      propertyName: `Number of kittens`,
      propertyType: PropertyType.Number,
      customBucket: {
        bucketSize: 25,
        max: 100,
        min: 0,
        offset: null,
      },
    },
  },
];

export const B2B_PROFILE_SEGMENT = [
  {
    user: {
      resourceType: `user`,
      dataGroupId: BILLING_DATA_GROUP_ID,
      propertyName: `Account Status`,
      propertyDefaultType: `string`,
      propertyType: `string`,
    },
  },
];

export const B2B_COHORT_SEGMENT = [
  [
    {
      cohort: {dataGroupId: BILLING_DATA_GROUP_ID, id: 14, name: `saved billing account cohort`, negated: false},
    },
  ],
];

export const INLINE_B2B_COHORT_SEGMENT = [
  [
    {
      cohort: {
        dataGroupId: BILLING_DATA_GROUP_ID,
        name: `inline billing account cohort`,
        negated: false,
        raw_cohort: {name: `inline billing account cohort`, selector: {}, behaviors: {}},
      },
    },
  ],
];

export const CUSTOM_EVENT_WITH_USER_FILTER = {
  event: {
    custom: true,
    id: 6,
    label: `View puppies`,
    value: `$custom_event:6`,
    can_view: true,
  },
  filters: [],
  filtersOperator: `or`,
};

export const CUSTOM_EVENT_DEFINITION_WITH_USER_FILTER = {
  name: `Custom event 1`,
  deleted: 0,
  alternatives: [
    {
      event: `Viewed report`,
      valid_segfilter: {
        filters: [
          {
            filter: {
              operator: `==`,
              operand: [`chrome`],
            },
            property: {
              source: `user`,
              type: `string`,
              name: `$browser`,
            },
            type: `string`,
            selected_property_type: `string`,
          },
        ],
        op: `and`,
      },
    },
  ],
  project_id: 3,
  id: 1,
  is_collect_everything_event: false,
  can_view: true,
};
